import { Descendant } from 'slate';

export const defaultInitialState: Descendant[] = [{ children: [{ text: '' }] }];
